export const useTaskSectionTranslation = () => {
    const client = useSanctumClient();

    /**
     * Auto-translate task sections when their values change
     * @param {Array} taskSections - Array of task sections to translate
     */
    const autoTranslateTaskSections = async (taskSections) => {
        if (!Array.isArray(taskSections) || taskSections.length === 0) {
            return taskSections;
        }

        const { autoTranslateObject } = useAutoTranslation();

        for (const taskSection of taskSections) {
            if (taskSection.value && typeof taskSection.value === 'object') {
                await autoTranslateObject(taskSection, ['value']);
            }
        }

        return taskSections;
    };

    /**
     * Save task sections with auto-translation
     * @param {Number} taskId - The task ID
     * @param {Array} taskSections - Array of task sections to save
     */
    const saveTaskSectionsWithTranslation = async (taskId, taskSections) => {
        // Auto-translate first
        await autoTranslateTaskSections(taskSections);

        // Then save via API
        try {
            const response = await client(`/api/tasks/${taskId}/sections`, {
                method: 'PUT',
                body: { task_sections: taskSections }
            });

            return response;
        } catch (error) {
            console.error('Failed to save task sections:', error);
            throw error;
        }
    };

    return {
        autoTranslateTaskSections,
        saveTaskSectionsWithTranslation
    };
};